// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2Cqc_","header":"ReportDetails_header__1Yuoa","title":"ReportDetails_title__3WADU","left":"ReportDetails_left__2AqIV"};